"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _RelateNodeGraph = _interopRequireDefault(require("../relate/RelateNodeGraph"));

var _RobustLineIntersector = _interopRequireDefault(require("../../algorithm/RobustLineIntersector"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ConsistentAreaTester =
/*#__PURE__*/
function () {
  function ConsistentAreaTester() {
    _classCallCheck(this, ConsistentAreaTester);

    ConsistentAreaTester.constructor_.apply(this, arguments);
  }

  _createClass(ConsistentAreaTester, [{
    key: "isNodeEdgeAreaLabelsConsistent",
    value: function isNodeEdgeAreaLabelsConsistent() {
      for (var nodeIt = this._nodeGraph.getNodeIterator(); nodeIt.hasNext();) {
        var node = nodeIt.next();

        if (!node.getEdges().isAreaLabelsConsistent(this._geomGraph)) {
          this._invalidPoint = node.getCoordinate().copy();
          return false;
        }
      }

      return true;
    }
  }, {
    key: "getInvalidPoint",
    value: function getInvalidPoint() {
      return this._invalidPoint;
    }
  }, {
    key: "hasDuplicateRings",
    value: function hasDuplicateRings() {
      for (var nodeIt = this._nodeGraph.getNodeIterator(); nodeIt.hasNext();) {
        var node = nodeIt.next();

        for (var i = node.getEdges().iterator(); i.hasNext();) {
          var eeb = i.next();

          if (eeb.getEdgeEnds().size() > 1) {
            this._invalidPoint = eeb.getEdge().getCoordinate(0);
            return true;
          }
        }
      }

      return false;
    }
  }, {
    key: "isNodeConsistentArea",
    value: function isNodeConsistentArea() {
      var intersector = this._geomGraph.computeSelfNodes(this._li, true, true);

      if (intersector.hasProperIntersection()) {
        this._invalidPoint = intersector.getProperIntersectionPoint();
        return false;
      }

      this._nodeGraph.build(this._geomGraph);

      return this.isNodeEdgeAreaLabelsConsistent();
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return ConsistentAreaTester;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return ConsistentAreaTester;
}();

exports.default = ConsistentAreaTester;

ConsistentAreaTester.constructor_ = function () {
  this._li = new _RobustLineIntersector.default();
  this._geomGraph = null;
  this._nodeGraph = new _RelateNodeGraph.default();
  this._invalidPoint = null;
  var geomGraph = arguments[0];
  this._geomGraph = geomGraph;
};